import { render } from "./companies-grid.vue?vue&type=template&id=3db442f4"
import script from "./companies-grid.vue?vue&type=script&lang=js"
export * from "./companies-grid.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__